<template>
    <div class="goods-item">
        <div class="item-wrap" @click.stop="toDetail">
            <div class="item-wrap-img">
                <img :src="cartItem.image" alt="">
                <div v-if="getLoginStatus.data.member_id&&+cartItem.goodsstock === 0 && getLoadSettingStatus.data.is_empty_stock === 0" class="not-goods-tag">缺货</div>
                <div v-if="cartItem.activity_type===8" class="presell-tag">预售</div>
                <i
                  v-if="+cartItem.member_id !== 0"
                  class="xpt-icons"
                  :class="{
                            'xpt-icons__manzeng': cartItem.activity_type == 5,
                            'xpt-icons__huodong': cartItem.activity_type == 4,
                            'xpt-icons__cuxiao': cartItem.activity_type == 3 && !cartItem.is_bargain,
                            'xpt-icons__tejia': cartItem.activity_type == 2 && +cartItem.is_seckill ===0,
                            'xpt-icons__miaosha': cartItem.activity_type == 2 && +cartItem.is_seckill ===1,
                          }"
                ></i>
            </div>
            <div class="item-wrap-info">
                <p class="name">{{cartItem.general_name}} {{cartItem.norms}}</p>
                <p class="company">{{cartItem.produce_unit}}</p>
                <div class="bottom">
                    <template v-if="cartItem.member_id">
                        <span class="price f15" v-if="+cartItem.is_view === 1">区域经销</span>
                        <span class="price f15" v-else-if="+cartItem.is_bargain === 1 && +cartItem.tag === 2" v-delivery-price>议价商品</span>
                        <span class="price" v-delivery-price v-else><b>￥</b><span >{{cartItem.jiage}}</span></span>
                    </template>
                    <span v-else class="price f15">会员可见</span>
                    <cart-btn
                      :btn-type="getGoodsType(item)"
                      @openCart="cartBtn(item,cartIconColor(item)?1:0)">
                    </cart-btn>
                </div>
            </div>
        </div>
        <div class="activity-info" v-if="getMsg">
            <span>{{cartItem.member_id ? getMsg:'会员可见'}}</span>
        </div>
        <!-- 购物车弹窗start(有库存) -->
            <cc-shop-cart
              getContainer="body"
              :isShowPopup="showcart"
              :cartItemData="cartItem"
              @close="showcart=false"
              :height="556"
              :HeaderHight="88"
              ref="shopCart"
            ></cc-shop-cart>
        <!-- 购物车弹窗end -->
        <!-- 缺货弹窗start-->
            <cc-nogoods-remind
              getContainer="body"
              :isShowPopup="shownogoods"
              :cartItem="cartItem"
              :height="426"
              @close="shownogoods=false"
              ref="nogoods"
            ></cc-nogoods-remind>
        <!-- 缺货弹窗end -->
    </div>
</template>

<script>
import Vue from 'vue'
import cartStep from '@/mixins/cartStep'
import Command from '@/mixins/command'
import { Lazyload } from 'vant'
import CartBtn from './../components/cart-btn.vue'

Vue.use(Lazyload)
export default {
  name: 'item',
  mixins: [cartStep, Command],
  components: {
    CartBtn
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      cartItem: this.item
    }
  },
  watch: {
    item () {
      this.cartItem = this.item
    }
  },
  computed: {
    getMsg () {
      const obj = {
        '2': 'special_content',
        '4': 'activity_introduc',
        '5': 'gifts_introduc'
      }
      const type = this.cartItem.activity_type + ''
      return this.cartItem[obj[type]]
    }
  },
  methods: {
    getGoodsType (item) {
      if (this.getLoginStatus.data.member_id) {
        if (item.is_view === 1) {
          return 1 // 区域经销
        } else if (item.type === 8) {
          // 预售商品
          return +item.presell_stock === 0 ? 2 : 0
        } else {
          // 议价商品
          if (+item.is_bargain === 1 && item.tag === 2) {
            return 1
          } else if (+item.goodsstock === 0 && this.getLoadSettingStatus.data.is_empty_stock === 0) {
            return 2
          } else {
            return 0
          }
        }
      } else {
        return 0
      }
    },
    cartBtn (item, cartColor) {
      this.cartBtnAlter(item, cartColor)
    },
    toDetail () {
      const { cartItem } = this
      // location.href = `/product/detail?id=${cartItem.id}&type=${cartItem.for_type === 2 ? 2 : 1}`
      this.$router.push({
        path: '/goods-details',
        query: { goods_id: cartItem.id, type: cartItem.for_type }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-item{
    width: 100%;
    min-height: 96px;
    box-sizing: border-box;
    padding: 15px 0 0;
    background: rgba(255,255,255,1);
    box-shadow:0px 1px 5px 0px rgba(230,229,229,0.7);
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
    .item-wrap{
        display: flex;
        margin-bottom: 15px;
        padding: 0 15px;
        &-img{
            height: 66px;
            width: 75px;
            border-radius: 4px;
            position: relative;
            overflow: hidden;
            .not-goods-tag{
                width: 100%;
                height: 16px;
                background: rgba(125,125,125,0.6);
                color: #ffffff;
                position: absolute;
                bottom: 0;
                left: 0;
                @include  center()
            }
            .presell-tag{
                position: absolute;
                width: 35px;
                height: 17px;
                font-size: 10px;
                background: #F78FE8;
                border-radius: 10px;
                color: #FFFFFF;
                top: 0;
                left: 0;
                @include center();
                color: #ffffff;
            }
            img{
                height: 100%;
            }
        }
        &-info{
            flex: 1;
            box-sizing: border-box;
            padding-left: 30px;
            display: flex;
            flex-direction: column;
            .name{
                color: #333333;
                font-size: 15px;
                @include ell(2);
            }
            .company{
                color: #777777;
                font-size: 12px;
                @include ell();
            }
            .bottom{
                display: flex;
                margin-top: 12px;
                justify-content: space-between;
                align-items: center;
                .price{
                    color: #EA2727;
                    font-size: 18px;
                    b{
                        font-size: 12px;
                    }
                }
                .btn{
                    width: 65px;
                    height: 24px;
                    border-radius: 12px;
                    color: #ffffff;
                    background-color: var(--APP_theme_color);
                    @include center()
                }
            }
        }
    }
    .activity-info{
        height: 30px;
        padding: 0 15px;
        border-top: 1px solid rgba(238,238,238,1);
        display: flex;
        align-items: center;
        color: #EC5F63;
        font-size: 10px;
        span{
            @include  ell();
        }

    }
}
</style>
